import type { LocaleMessageBundle } from '../../types'

export const productBrandMessages: LocaleMessageBundle = {
  vi: {
    'product.brand.model': 'Thương hiệu',
    'product.brand.title': 'Thương hiệu',
    'product.brand.fields.code': 'Mã thương hiệu',
    'product.brand.fields.name': 'Tên thương hiệu',
    'product.brand.fields.description': 'Mô tả',
    'product.brand.fields.status': 'Trạng thái',
    'product.brand.status.active': 'Đang dùng',
    'product.brand.status.inactive': 'Tạm ngưng',
    'product.brand.actions.add': 'Thêm thương hiệu',
    'product.brand.actions.create': 'Thêm thương hiệu',
    'product.brand.actions.update': 'Cập nhật thương hiệu',
    'product.brand.actions.submitCreate': 'Tạo mới',
    'product.brand.actions.submitUpdate': 'Cập nhật',
    'product.brand.actions.cancel': 'Đóng',
    'product.brand.actions.delete': 'Xóa',
    'product.brand.actions.deleteTitle': 'Xóa thương hiệu',
    'product.brand.deleteConfirm': 'Bạn có chắc muốn xóa thương hiệu {name}?',
    'product.brand.dialog.createSubtitle':
      'Tạo thương hiệu mới để phân loại và quản lý sản phẩm tốt hơn',
    'product.brand.dialog.updateSubtitle':
      'Cập nhật thông tin thương hiệu để quản lý sản phẩm tốt hơn',
    'product.brand.placeholders.code': 'Nhập mã thương hiệu',
    'product.brand.placeholders.name': 'Nhập tên thương hiệu',
    'product.brand.placeholders.description': 'Nhập mô tả thương hiệu (không bắt buộc)',
    'product.brand.help.status':
      'Chỉ những thương hiệu đang dùng mới được hiển thị khi chọn sản phẩm',
    'product.brand.help.statusTitle': 'Trạng thái thương hiệu là gì?',
    'product.brand.help.statusDescription':
      'Chỉ những thương hiệu đang dùng mới hiển thị khi chọn sản phẩm trong hệ thống.',
    'product.brand.errors.saveFailed': 'Không thể lưu thương hiệu. Vui lòng thử lại.',
  },
  en: {
    'product.brand.model': 'Brand',
    'product.brand.title': 'Brands',
    'product.brand.fields.code': 'Brand code',
    'product.brand.fields.name': 'Brand name',
    'product.brand.fields.description': 'Description',
    'product.brand.fields.status': 'Status',
    'product.brand.status.active': 'Active',
    'product.brand.status.inactive': 'Inactive',
    'product.brand.actions.add': 'Add brand',
    'product.brand.actions.create': 'Create brand',
    'product.brand.actions.update': 'Update brand',
    'product.brand.actions.submitCreate': 'Create',
    'product.brand.actions.submitUpdate': 'Update',
    'product.brand.actions.cancel': 'Cancel',
    'product.brand.actions.delete': 'Delete',
    'product.brand.actions.deleteTitle': 'Delete brand',
    'product.brand.deleteConfirm': 'Are you sure you want to delete brand {name}?',
    'product.brand.dialog.createSubtitle':
      'Create a new brand to classify and manage products better',
    'product.brand.dialog.updateSubtitle': 'Update brand information to manage products better',
    'product.brand.placeholders.code': 'Enter brand code',
    'product.brand.placeholders.name': 'Enter brand name',
    'product.brand.placeholders.description': 'Enter brand description (optional)',
    'product.brand.help.status': 'Only active brands are shown when selecting products',
    'product.brand.help.statusTitle': 'What is brand status?',
    'product.brand.help.statusDescription':
      'Only active brands are shown when selecting products in the system.',
    'product.brand.errors.saveFailed': 'Unable to save brand. Please try again.',
  },
}
